import { Col, Row } from 'antd';
import PanelModeToggle from 'components/Global/PanelModeToggle';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BellSvg, SettingsSvg } from 'utils/svgs';
import UserNameBox from '../UserNameBox';
import styles from './index.module.scss';
import './index.scss';
import { checkPermission } from 'utils/utils';

const Header = () => {
	const navigate = useNavigate();
	const [formattedDate, setFormattedDate] = useState("");
	const [greeting, setGreeting] = useState("Good Morning");

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);

	const isUsersPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Users',
		permission: ['view'],
	});

	useEffect(() => {
		// Format the date
		const formatDate = () => {
			const options: Intl.DateTimeFormatOptions = {
				weekday: "long",
				day: "numeric",
				month: "long",
				year: "numeric",
			};
			return new Date().toLocaleDateString("en-GB", options);
		};

		// Determine greeting based on the current time
		const getGreeting = () => {
			const hour = new Date().getHours();
			if (hour < 12) return "Good Morning";
			if (hour < 18) return "Good Afternoon";
			return "Good Evening";
		};

		setFormattedDate(formatDate());
		setGreeting(getGreeting());
	}, []);

	const handleNavigatePermissionWise = (currentPath: string) => {
		const targetPath = currentPath.includes('settings') ? '/' : '/settings';
		navigate(targetPath);
	};

	const { data: userData } = useSelector((state: any) => state?.userProfile);

	return (
		<header className={styles['header']}>
			<Row className={styles['header__wrapper']} align={'middle'} justify={'space-between'}>
				<Col className={styles['header__details-left']}>
					<div className={styles['header__details-left--text']}>
						<p>{greeting}, {userData?.firstName || "Guest"}!</p>
						<p className={styles['header__details-left--text__subtext']}> Today: <span style={{ color: "#949494" }}>{formattedDate}</span></p>
					</div>
				</Col>

				<Col className={styles["header__details-right"]}>
					<PanelModeToggle compact />
					<div className={styles["header__details-right--icons"]}>
						<button className={styles["navButton"]}>
							<BellSvg />
						</button>
						{isUsersPermission &&
							<button className={styles["navButton"]}
								onClick={() => { handleNavigatePermissionWise(window.location.pathname) }}>
								<SettingsSvg />
							</button>
						}
					</div>

					<div className={styles["header__details-right--divider"]}></div>

					<div className={styles["header__details-right--user"]}>
						<div className={styles["header__details-right--user-logo"]}>
							<UserNameBox name={`${userData?.firstName} ${userData?.lastName}`} />
						</div>
						<div className={styles["header__details-right--user-details"]}>
							<p className={styles["header__details-right--user-name"]}>
								{userData?.firstName || "Guest"}
							</p>
							<p className={styles["header__details-right--user-profile"]}>
								{userData?.roleName || "Employee"}
							</p>
						</div>
					</div>
				</Col>
			</Row>
		</header>
	);
};

export default Header;
